import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  collapseContainer: {
    overflowY: 'auto',
  },
}));
